enum FilterMode {
  Exclude = 'Exclude',
  Include = 'Include',
}

export default FilterMode;
